import { MESApiService } from "@dexteel/mesf-core";
import { get } from "lodash-es";

export type NextLocationAsset = {
	AssetId: number;
	AssetName: string;
};

export const getNextLocationAssets = async () => {
	const apiService = new MESApiService();

	const resp = await apiService.callV2("[FAB].[GetNextLocationAssets]", []);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as NextLocationAsset[];
	} else {
		throw new Error(resp.message || "Error fetching next location assets");
	}
};
